import React from 'react';
import './Footer.css';

function footer() {
    return (
            <div className="footer-body">
                <img src="../../images/signature-react2.webp" alt="my-signature" />
            </div>
    )
}

export default footer;